/**
 * Qué nombre usar para saludar en el panel, y qué hacer cuando no hay ninguno.
 *
 * ── EL FALLO QUE CIERRA (17-sep-2026) ───────────────────────────────────────
 * El panel saludaba con «Hola, » —coma y nada detrás— a quien entraba por invitación.
 * `Dashboard.js` leía `cliente.nombre`, y ese campo lo escribe el alta de PAGO; el alta
 * por invitación crea el documento de miembro con `displayName` y nunca toca
 * `clientes/{uid}.nombre`. El dato existía, en el documento que el saludo no miraba.
 *
 * Medido: el owner tenía `clientes.nombre = "Rodrigo"` y saludaba bien; el invitado tenía
 * el campo ausente y `displayName: "rodgum"` en su member doc.
 *
 * ── POR QUÉ UNA FUNCIÓN PURA Y NO TRES `||` EN EL JSX ───────────────────────
 * Porque el orden de la cadena ES la decisión, y un `a || b || c` inline no se puede
 * probar sin montar el panel entero. Aquí se ejecuta.
 *
 * CommonJS a propósito, igual que `reintentoDeRed.js`: así lo carga la suite de
 * `functions/`, que es la única puerta de build automática del repositorio. Un test en
 * `src/` no corre en el pre-commit — es documentación ejecutable que nadie ejecuta.
 *
 * ── LO QUE NO HACE, Y ES DELIBERADO ────────────────────────────────────────
 * NO crea `clientes/{uid}` para los invitados. Sería escribir un documento de tenant
 * personal para alguien que sólo pertenece a una organización, y ese documento tiene
 * lectores que decidirían cosas sobre él (plan, contexto, límites). El saludo no
 * justifica inventar un tenant.
 *
 * Tampoco usa el `displayName` de Firebase Auth: medido el 17-sep, viene `undefined` en
 * las dos cuentas reales del proyecto, así que sería un eslabón que nunca aporta.
 */

/**
 * @param {{clienteNombre?: any, displayNameMiembro?: any, email?: any}} fuentes
 * @returns {string|null} el nombre, o `null` si no hay ninguno utilizable.
 */
function nombreParaSaludo({ clienteNombre, displayNameMiembro, email } = {}) {
  // `typeof === 'string'` y no truthy: un valor no-cadena (un objeto guardado por error,
  // un número) pasaría el truthy y reventaría en el `.trim()` o se pintaría como
  // «[object Object]». Es la misma familia que el `userEmail.split` que tumbó el
  // manejador de pago el 08-ago.
  const limpio = (v) => (typeof v === 'string' ? v.trim() : '');

  const delCliente = limpio(clienteNombre);
  if (delCliente) return delCliente;

  // El member doc de la organización ACTUAL. Lo escribe el alta por invitación
  // (`organizationRoutes.js`) derivándolo del correo.
  const delMiembro = limpio(displayNameMiembro);
  if (delMiembro) return delMiembro;

  // Último recurso: el prefijo del correo. No es un nombre, pero es reconocible —
  // es lo que la propia persona escribió al registrarse.
  const correo = limpio(email);
  const prefijo = correo.includes('@') ? correo.split('@')[0].trim() : '';
  if (prefijo) return prefijo;

  // Sin nada utilizable: `null`, y quien llame usa el saludo SIN coma. Devolver cadena
  // vacía dejaría «Hola, », que es justo el defecto que esto cierra: una coma que
  // promete un nombre que no llega se lee como un fallo, no como un saludo neutro.
  return null;
}

module.exports = { nombreParaSaludo };
